<template>
    <div id="vehicle_model_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="fuelHeaderupdate" v-if="$route.params.id > 0">Update Fuel Ticket</span>
                    <span class="page-title" id="fuelHeaderCreate" v-else>Add Fuel Ticket</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackTicketlList" >
                            <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content fuel-ticket-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" v-on:submit.prevent="getReading" v-show="!displaySchedule" class="form-horizontal basic-form-container form-custom-select" id="fuelTicketCreate">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="field-error" v-if="user_location_error!=''">{{user_location_error}}</div>
                                    <!-- <div class="col form-group mt-4" v-if="sequence > 0">
                                        <label class="control-label" for="sequence_id"  v-if="sequence > 0">#Sequence No: </label>
                                        <span class="label">{{sequence}}</span>
                                    </div> -->
                                    <div class="col form-group pt-md-4">
                                        <div class="custom-checkbox">
                                            <label for="is_miscellaneous" class="checkbox-custom">Miscellaneous
                                            <input type="checkbox" v-model="is_miscellaneous" id="is_miscellaneous" name="is_miscellaneous" v-on:click="isMiscellaneous($event)">
                                            <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div v-if="$route.params.id > 0" class="col form-group">
                                        <label class="control-label require" for="sequence">Sequence # :</label>
                                        <input disabled="disabled" type="text" class="form-control" v-model="sequence" id="sequence" placeholder="Sequence No" name="sequence" @blur="onSequenceTypeIn()" @keypress="isIntegerCheck($event)">
                                        <div class="field-error">{{ sequence_no_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="date_time">Date Time:</label>
                                        <div class="input-group">
                                            <date-picker  disabled="true" placeholder="MM/DD/YYYY" id="date_time" name="date_time"  v-model="date_time" @input='getFuelPrice()' :config="optionsDate" v-if="userRole=='fueler'"></date-picker>
                                            <date-picker placeholder="MM/DD/YYYY" id="date_time" name="date_time"  v-model="date_time" @input='getFuelPrice()' :config="optionsDate" v-else></date-picker>
                                            <label for="date_time" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ date_time_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                      <label class="control-label require" for="billable_code">Bill Type :</label>
                                      <v-select v-model="bill_type" class="close-remove" name="bill_type" placeholder="Select Bill Type." label="text" :options="billableCodeArr" :id="bill_type">
                                      </v-select>
                                      <div class="field-error">{{bill_type_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                      <label class="control-label" for="location_id">Location:</label>
                                      <!-- <input type="text" disabled class="form-control" v-model="location_id" id="location_id" placeholder=" Location" name="location_id"> -->
                                      <v-select v-model="location_id" name="location_id" placeholder="Select Location"
                                          label="text" @input="onLocationSelect()"
                                          :options="locationArr">
                                      </v-select>
                                      <div class="field-error">{{location_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="product_id">Product:</label>
                                        <v-select v-model="product_id" name="product_id" placeholder="Select Product"
                                            label="text"
                                            :options="product_Arr"  @input="onProductSelect($event)">
                                        </v-select>
                                        <div class="field-error">{{ product_error_msg }}</div>
                                    </div>

                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="pump_id">Pump# :</label>
                                        <input type="text" disabled class="form-control" v-model="pump_no" id="pump_no" placeholder="Pump No" name="pump_no">
                                    </div> -->
                                    <div class="col form-group">
                                        <label class="control-label" for="department_id">Pump:</label>
                                        <v-select v-model="pump_mapper_id" name="pump_mapper_id" placeholder="Select Pump"
                                                    label="text"
                                                    :options="pumpMapperArr" >
                                        </v-select>
                                        <div class="field-error">{{ pump_error_msg }}</div>
                                    </div>
                                    <div class="col form-group" v-if="!is_miscellaneous">
                                        <label class="control-label" for="vehicle_id">Unit:</label>
                                        <v-select v-model="vehicle_id" name="vehicle_id"
                                                    label="text" :filterable="false" :options="vehicleArr"
                                                    @search="onSearchVehicle"
                                                    @input="onAssetChange(),getFuelPrice()"
                                                    placeholder="Select Asset" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Asset...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ vehicle_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label :class="billTypeClass" for="customer_id">Customer:</label>
                                        <v-select v-model="customer_id" name="customer_id"
                                                    label="text" :filterable="false" :options="customerArr"
                                                    @search="onSearchCustomer"
                                                    @input="getFuelPrice()"
                                                    placeholder="Select Customer" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Customer...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ customer_error_msg }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label" for="reference_no">{{ref_label}}:</label>
                                        <input type="text" class="form-control" v-model="reference_no" id="reference_no" placeholder="Enter Reference No." name="reference_no">
                                        <div class="field-error">{{reference_no_error_msg}}</div>
                                    </div>
                                    <!-- <div class="col form-group" v-if="is_miscellaneous">
                                        <label class="control-label" for="reference_no">Vin:</label>
                                        <input type="text" class="form-control" v-model="vin" id="vin" placeholder="Enter Vin No." name="vin">
                                    </div> -->
                                    <div class="col form-group">
                                        <label class="control-label require" for="capacity">Quantity:</label>
                                        <input type="number" class="form-control" v-model="quantity" id="quantity" @input="calculateSubTotal()" placeholder="Enter quantity" name="quantity" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{quantity_error_msg}}</div>
                                    </div>
                                    <div class="col form-group" v-if="userRole!='fueler'">
                                        <label class="control-label require" for="unit_id" >UOM:</label>
                                        <v-select v-model="measurement_unit_id" name="measurement_unit_id" placeholder="Select UOM"
                                                    label="text"
                                                    :options="vomArr">
                                        </v-select>
                                        <div class="field-error">{{ measurement_unit_error_msg }}</div>
                                    </div>
                                    <!-- <div class="col form-group" v-if="vehicle_id!=null">
                                        <label class="control-label require" for="odometer_reading">Odometer Reading:</label>
                                        <input type="text" class="form-control" v-model="odometer_reading" id="odometer_reading" placeholder="Enter Reading" name="odometer_reading">
                                        <div class="field-error">{{ odometer_reading_error_msg }}</div>
                                    </div> -->
                                    <div class="col form-group" v-if="userRole!='fueler'">
                                        <label class="control-label" for="pump_id">#PO:</label>
                                        <input type="text" class="form-control" v-model="po_id" id="po_id" placeholder="PO No." name="po_id">
                                    </div>
                                    <!-- <div class="col form-group" v-if="userRole!='fueler'">
                                        <label class="control-label" for="pump_id">Driver Id:</label>
                                        <input type="text" class="form-control" v-model="driver_id" id="driver_id" placeholder=" Driver Id" name="driver_id">
                                    </div> -->
                                        <div class="col form-group" v-if="userRole!='fueler'">
                                            <label class="control-label" for="pump_id">Card Number:</label>
                                            <input type="text" class="form-control" v-model="card_no" id="card_no" placeholder="Card Number" name="card_no">
                                        </div>
                                        <div class="col form-group" v-if="userRole!='fueler'">
                                            <label class="control-label" for="pump_id">Notes:</label>
                                            <textarea class="form-control" v-model="notes" id="notes" placeholder=" Notes" rows="3" name="notes"></textarea>
                                        </div>
                                        <template v-if="sectionArr && sectionArr.length">
                                            <template v-for="(sec,scval) in sectionArr">
                                                <div class="col form-group col-md-2" :key="scval">
                                                    <template v-if="sec.section_code.toLowerCase() == 'dist'">
                                                        <label class="control-label require" for="notes">Odometer:</label>
                                                        <input type="text" class="form-control" v-model="sec.reading" id="miles" autocomplete="off" :placeholder="'Odometer'" name="miles" @keypress="isAmountCheck($event)">
                                                    </template>
                                                    <template v-else>
                                                        <label class="control-label require" for="notes">{{sec.sectionName}}:</label>
                                                        <input type="text" class="form-control" v-model="sec.reading" id="miles" autocomplete="off" :placeholder="sec.sectionName" name="miles" @keypress="isAmountCheck($event)">
                                                    </template>
                                                    <div class="field-error">{{ sec.reading_error }}</div>
                                                </div>
                                            </template>
                                        </template>
                                        <div class="col form-group" v-if="userRole=='fueler'">
                                            <label class="control-label">SIGNATURE:</label>
                                            <div id="app" class="pull-left">
                                                <VueSignaturePad class="form-signature" v-if="signature == ''"
                                                                    height="200px"
                                                                    ref="custsignaturePad"
                                                                    style="border: 1px solid #bababa;margin-top:0;margin-bottom:14px;border-radius:5px;"
                                                />
                                                <img v-if="signature != ''" :src="signature" style="width:500px,height:200px;" alt="">
                                                <div v-if="signature == ''">
                                                    <button type="submit" class="btn btn-primary" v-on:click.prevent="custsave" >
                                                        <i class="fp-save"> </i>  Done
                                                    </button>
                                                    <button type="submit" class="btn btn-tertiary" v-on:click.prevent="custundo" >
                                                        <i class="fp-import"> </i> Undo
                                                    </button>
                                                </div>
                                                <div v-else>
                                                    <button class="btn btn-primary" v-on:click.prevent="signature = ''">Edit</button>
                                                </div>
                                                <div class="field-error">{{signature_error_msg}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <template v-if="cost_error_msg!=''">
                                        <div class="field-error">{{cost_error_msg}}</div>
                                    </template>
                                    <div class="table-responsive-sm" v-if="userRole!='fueler'">
                                        <table aria-describedby="table" class="table table-sm table-bordered">
                                            <thead>
                                                <tr class="table-primary">
                                                    <th scope="col" :class="billTypeClass">Price</th>
                                                    <th scope="col" class="require">Total</th>
                                                    <!-- <th scope="col" class="require">Tax (%)</th> -->
                                                    <!-- <th scope="col" class="require">Tax</th> -->
                                                    <th scope="col" class="require">Tax Amount</th>
                                                    <th scope="col" class="require">Ticket Total </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <input type="text" :disabled="priceDisabled" @keypress="isAmountCheck($event)"
                                                        class="form-control text-right" v-model="price_val"
                                                        @blur="price_val = leaveFocusFT($event)"
                                                        @focus="price_val = enterVal($event)"
                                                        id="price_val" placeholder="Price" name="price_val">
                                                        <div class="field-error">{{price_error_msg}}</div>
                                                    </td>
                                                    <td>
                                                        <input type="text" disabled class="form-control text-right" v-model="total" id="total" placeholder="Total" name="total">
                                                    </td>
                                                    <!-- <td>
                                                        <input type="text" disabled class="form-control text-right" v-model="tax" id="tax" placeholder="Tax" name="tax">
                                                    </td> -->
                                                    <td>
                                                        <input type="text" disabled class="form-control text-right" v-model="tax_amount" id="tax_amount" placeholder="Tax Amount" name="tax_amount">
                                                    </td>
                                                    <td>
                                                        <input type="text" disabled class="form-control text-right" v-model="ticket_total" id="ticket_total" placeholder="Ticket Total" name="ticket_total">
                                                        <div class="field-error">{{ticket_total_error_msg}}</div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="field-error">{{common_error_msg}}</div>
                                    <div class="form-group">
                                        <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                            <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                            <strong id="errorMsg" class="field-error"> {{ errorMsg }}</strong>
                                        </div>
                                    </div>
                                    <div class="btn-groups">
                                        <button type="submit" id="createVehicleModelBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="getReading" >
                                            <i class="fp-reload"> </i>  Update
                                        </button>

                                        <button type="submit" id="createVehicleModelBtn" v-else class="btn btn-primary" v-on:click.prevent="getReading" >
                                        <i class="fp-save"> </i>  Save
                                        </button>

                                        <button type="button" id="createAndContinueVehicleModelBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="getReading(flag='Save and Continue')" >
                                        <i class="fp-save-continue"> </i>  Save and Continue
                                        </button>

                                        <button type="button" id="createVehicleModelBtn" v-if="$route.params.id > 0 " class="btn btn-primary" v-on:click.prevent="getReading(flag='process')" >
                                            <i class="fp-reload"> </i>  Update & Process
                                        </button>

                                        <button type="button" id="cancelVehicleModelBtn" class="btn btn-tertiary" v-on:click.prevent="BackTicketlList" >
                                        <i class="fp-close"> </i>  Cancel
                                        </button>
                                    </div>
                            </form>
                            <app-program-trigger ref="triggerEnable" :from="'fuel'" v-show="displaySchedule"></app-program-trigger>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import {contractMixins} from '../mixins/contractMixins';
import moment from 'moment'
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.min.css";
import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);
import ProgramTrigger from "@/components/ProgramTrigger.vue";
Vue.component("app-program-trigger", ProgramTrigger);


Vue.use(FullCalendar);

export default {
  name: "FuelTicketCreate",

  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Fuel Ticket  | " +process.env.COPYRIGHT_NAME : "Create Fuel Ticket | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins,contractMixins],
  data: () => ({
        permissions: [],
        cantAccessPage: "",
        location_id: "",
        vehicle_id:null,
        customer_id:null,
        reference_no:"",
        po_id:"",
        driver_id:"",
        card_no:"",
        quantity:0,
        price_val:0,
        total:0,
        tax:0,
        ticket_total:0,
        billableCodeArr:[],
        bill_type:null,
        productArr:[],
        locationArr:[],
        vehicleArr:[],
        customerArr:[],
        vomArr:[],
        measurement_unit_id:null,
        tankArr:[],
        department_id:null,
        shopArr:[],
        loading:false,
        pump_no:'',
        status:{text:'Entered',value:'entered'},
        optionsDate: {
        format: 'MM/DD/YYYY hh:mm:ss a',
//              useCurrent: true,
        //          minDate:moment().millisecond(0).second(0).minute(0).hour(0),//new Date(),
        showClose: true,
        },
        date_time:moment().format("MM/DD/YYYY hh:mm:ss a"),
        sequence:'',
        product_id:null,
        signature:'',
        date_time_error_msg:"",
        product_error_msg:"",
        price_error_msg:"",
        reference_no_error_msg:"",
        department_error_msg:"",
        location_error_msg: "",
        vehicle_error_msg:"",
        customer_error_msg:"",
        quantity_error_msg: "",
        measurement_unit_error_msg:"",
        bill_type_error_msg:"",
        status_error_msg:"",
        ticket_total_error_msg:"",
        cost_error_msg:"",
        signature_error_msg:"",
        fuelFlag:0,
        userRole:'',
        user_location_error:"",
        fuelTicketStatusArr:[{text:'Entered',value:'entered'},{text:'Processed',value:'processed'},{text:'Billed',value:'billed'}],
        common_error_msg:"",
        odometer_reading:"",
        odometer_reading_error_msg:"",
        priceDisabled:true,
        displaySchedule:false,
        errorMsg:'',
        sales_tax:0,
        sectionArr:[],
        is_miscellaneous:false,
        ref_label : 'Reference#',
        notes:'',
        tax_amount:0,
        diesel_tax : 0,
        dtax :'',
        aft_tax:0,
        requestInprogress:false,
        // vin:'',
        sequence_no_error_msg:"",
        sequence_duplicate:false,
        itemCode:"",
        seqCheck : 0,
        pumpMapperArr:[],
        pump_mapper_id:'',
        pump_error_msg:"",
        product_Arr:[],
        processflag:0,
        billTypeClass: "control-label require",
        currentFlag:''
  }),
  watch: {

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_fuel_ticket') {
                        self.cantAccessPage = true;

                    }
                }
            }

        },
        bill_type: function (){
            var self = this;
            if(self.bill_type == 1 || self.bill_type.value == 1){
              self.billTypeClass = "control-label require";
            }else{
                self.billTypeClass = "control-label";
            }
        },
        price_val:function () {

            var self = this;
            var taxValue = 0;

            if ( self.quantity != "" && self.price_val != "" ) {

                self.total = self.amountFormat(self.quantity * self.removeFormat(self.price_val));

                if ( self.tax > 0 ) {
                    // if product is DEF only calculate sales tax
                    if ( self.product_id.item_code == 'DEF' ||  self.product_id.item_code == 'EXTDEF' ) {
                        taxValue = ( self.removeFormat(self.total) * parseFloat(self.tax) );
                    } else {
                        taxValue = ( self.removeFormat(self.total) * parseFloat(self.tax) );
                        taxValue += ( self.removeFormat(self.total) * parseFloat(self.aft_tax) );
                        taxValue += ( self.removeFormat(self.quantity) * self.diesel_tax );
                    }

                    self.tax_amount = parseFloat(taxValue).toFixed(4);

                } else {
                    taxValue = self.removeFormat(parseFloat(self.tax_amount));
                }

                // taxValue = ( self.removeFormat(self.price_val) * self.tax );
                // taxValue += ( self.removeFormat(self.price_val) * self.diesel_tax );
                self.ticket_total = self.amountFormat(self.removeFormat(self.total) + taxValue);
                // self.tax_amount = parseFloat(taxValue.toFixed(2));
            }
            //self.ticket_total = self.amountFormat(self.ticket_total);

        },
        vehicle_id:function(vehicleId) {
            var self = this;

            var path = window.location.pathname;
            var segments = path.split("/");


            //to avoid populate customer while update fuel ticket
            if (segments[3]) {
                return;
            }
            if (vehicleId != null) {

                if (vehicleId.vehicle_type_id != undefined){
                    self.getSectionForReading(vehicleId.vehicle_type_id,vehicleId.unit_no);
                }
            }else{
              self.sectionArr = [];
            }
        },
        productArr: function(newVal, oldVal){
            var self = this;
            if(newVal.length != 0){
                self.onLocationSelect();
            }
        }
  },
  beforeMount() {
    var self = this;


  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        var userObj = JSON.parse(localStorage.getItem("user_obj"));

      if (userObj != null) {
        if(userObj && userObj.location_id != null && userObj.location_id  != ''){
                self.location_id = {value: userObj.location_id, text: userObj.locationName + " | " + userObj.locationCode};
        }
        if ( userObj.roles.length > 0) {
            for(var i = 0; i < userObj.roles.length; i++){
                if (userObj.roles[i].name == 'fueler') {
                    self.userRole = userObj.roles[0].name;
                }
            }
        }

      }
      var productFlag='';
      var roleViseFlag='';
       if(self.userRole == 'fueler')
       {
           self.checkFuelReading();
           productFlag='fuelislandproductfueler';
           roleViseFlag = "fueler";
       }else{
           productFlag='fuelislandproduct';
       }
        self.loadFieldData(['measurementUnit','shop','fuelbillablecode',productFlag, roleViseFlag,'fuelLocations']);

      var path = window.location.pathname;
        var segments = path.split("/");

        if (segments[3]) {

            setTimeout(function(){
                self.loadFuelTicket();
            },500);

        }
        // else{
        //    self.getSequenceNo();
        // }

  },
  methods: {
        leaveFocusFT: function (evt) {
            console.log("LeaveFocus");
            evt = (evt) ? evt : window.event;
            if (evt.target.value.indexOf(",") == -1) {
                console.log("IF");
                return this.amountFormat(evt.target.value,4);
            } else {
                console.log("ELSE");
                var amount = evt.target.value.replace(/\,/g,"");
                return this.amountFormat(amount,4);
            }
        },
        getSectionForReading:function(ttid,uid){
            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/section-by-truck-type/fetch",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    vehicle_type_id:ttid,
                    unit_no:uid
                },
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.sectionArr = data.content;
                        // self.taskArr[index].warrantyArr = data.content;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'get-section');
                }
            });

        },
        isMiscellaneous: function(e) {
            var self = this;

            if(e.target.checked) {
                // self.priceDisabled = false;
                // self.showMiscellaneousFields = true;
                self.is_miscellaneous = true;
                // self.disableAssetField = true;
                self.vehicle_id = null;
                // self.customer_id = {text:"001-00000000-000 | MISCELLANEOUS | Existing",value:0,stage:"existing"};
                self.customer_error_msg = "";
                self.ref_label = 'Unit#';
                // self.priceDisabled = false;
            } else {

                // self.showMiscellaneousFields = false;
                self.customer_id = null;
                self.is_miscellaneous = false;
                self.reference_no = '';
                // self.disableAssetField = false;
                self.ref_label = 'Reference#';
            }
        },

        BackTicketlList() {
            var self = this;
            self.$router.push("/fuel-ticket/list");
        },
        checkFuelReading(){
            var self = this;
            self.loading = true;
            $.ajax({
              url: process.env.ROOT_API + "/fuel-reading/check",
              type: "GET",
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;
                  if(data.status=='location_error')
                  {
                      self.user_location_error="User not mapped with any location please contact admin.";
                  }
                  if(data.status=='not_found'){

                      self.$router.push({ name: 'FuelReadingCreate',query:{flag:"fuelTicket" }})
//                      self.$router.push("/fuel-reading/create");
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,false,'fuel-product-load-by-location')
              }
            });
        },
        calculateSubTotal(){

            var self = this;

            var taxValue = 0;
            if (self.quantity != "" && self.price_val != "") {
                self.total = self.amountFormat(self.quantity * self.removeFormat(self.price_val));
                console.log("total == "+self.total);
                if (self.tax > 0) {
                    // if product is DEF only calculate sales tax
                    if ( self.product_id.item_code == 'DEF' ||  self.product_id.item_code == 'EXTDEF' ) {
                        taxValue = ( self.removeFormat(self.total) * parseFloat(self.tax) );
                    } else {
                        taxValue = ( self.removeFormat(self.total) * parseFloat(self.tax) );
                        taxValue += ( self.removeFormat(self.total) * parseFloat(self.aft_tax) );
                        taxValue += ( self.removeFormat(self.quantity) * self.diesel_tax );
                    }

                    self.tax_amount = parseFloat(taxValue).toFixed(4);
                }else{
                    taxValue = parseFloat(self.tax_amount);
                }
                // console.log(self.removeFormat(self.quantity) +'*'+ parseFloat(self.diesel_tax));

                console.log("tax value == "+taxValue);
                console.log("remove format value == "+self.removeFormat(self.total));
                self.ticket_total = self.amountFormat(self.removeFormat(self.total) + taxValue);
                console.log("ticket total value == "+self.ticket_total);
            }
        },
        onLocationSelect(){
            var self = this;
            self.product_Arr =[];
            if ( self.location_id.value != '' && self.location_id.value != undefined) {

                self.location = self.location_id.value;
                //set product to selected location
                for ( var j =0; j < self.productArr.length; j++ ) {

                    if(self.productArr[j].location_id == self.location){
                        self.product_Arr.push(self.productArr[j]);
                    }
                }
            }
        },
        onProductSelect(event){

            var self = this;
            self.pump_mapper_id = null;
            if ( self.product_id != null && self.product_id != '' )
            {
                self.location_id = self.product_id.location;
                self.pump_no = self.product_id.tank_no;
                self.priceDisabled = true;
                self.itemCode = self.product_id.item_code;
                if ( self.product_id.item_cat_code.toLowerCase() == "fuel" ) {
                    self.getFuelPrice();
                } else {
                    self.price_val = 0;
                    self.priceDisabled = false;
                }
                self.loadFieldData(['pump_mapper'],self.product_id.value);

            } else {

                self.location_id='';
                self.pump_no='';
            }


        },
        onSearchCustomer(search, loading) {
        var self = this;
        if (search.length > 2) {
            loading(true);
            self.searchField(loading, search, 'customer', '');
        }
        },
        onSearchVehicle(search, loading) {
        var self = this;
        if (search.length > 3) {

            loading(true);
            self.searchField(loading, search, 'vehicle', '');
        }
        },
        custundo() {
            this.$refs.custsignaturePad.undoSignature();
        },
        custsave() {
            this.signature_error_msg = "";

            const { isEmpty, data } = this.$refs.custsignaturePad.saveSignature();

            if(!isEmpty){
                this.signature = data;
            }else{
                //if sign1 is empty or blank show validation message
                this.signature_error_msg = "Please add the signature first and then click on Done.";
            }
        },
        getFuelPrice(){

            var self = this;
            var productId=0;
            var vehicleId=0;
            var customerId=0;
            var ticketDate='';
            var path = window.location.pathname;
            var segments = path.split("/");
            self.cost_error_msg="";

            //if product category is external fuel than no need to look for cost
            if(self.product_id != null && self.product_id.value){
              if ( self.product_id.item_cat_code.toLowerCase() == "fuelns" ) {
                  return;
              }
            }

            if(self.fuelFlag==0) {

                if (self.product_id != null && self.product_id.value && self.date_time != null && self.date_time != '') {

                    productId = self.product_id.value;

                    if (self.vehicle_id != null && self.vehicle_id.value) {
                        vehicleId = self.vehicle_id.value;
                    }
                    if (self.customer_id != null && self.customer_id.value) {
                        customerId = self.customer_id.value;
                    }
                    ticketDate = self.date_time;

                    //check ticket is billable or not
                    var isBillable = 1;
                    if ( self.bill_type && self.bill_type.value != 1 ) {
                        isBillable = 0;
                    }

                    var fields = {
                        productId: productId,
                        vehicle_id: vehicleId,
                        customer_id: customerId,
                        ticket_date: ticketDate,
                        isBillable: isBillable

                    };
                    self.loading=true;
                    $.ajax({
                        url: process.env.ROOT_API + "/fuel/price",
                        type: "post",
                        crossDomain: true,
                        headers: this.ajxHeaders,
                        data: fields,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            if (data.status == "success") {

                                if (data.code == 200) {

                                    if ( data.content.flag == 'no_cost' )
                                    {
                                        self.price_val= self.amountFormat(data.content.price,4);
                                        self.cost = data.content.cost;
                                        self.tax = parseFloat(data.content.tax_amt);
                                        self.sales_tax = data.content.sales_tax;
                                        self.diesel_tax = data.content.diesel_tax;
                                        self.dtax = data.content.dtax;

                                        var tx = 0;
                                        if (segments[3]) {

                                            if ( self.tax > 0 ) {

                                                if ( self.quantity > 0 ) {
                                                    tx = parseFloat(self.cost) * parseFloat(self.tax);
                                                    tx += parseFloat(self.quantity) * parseFloat(self.diesel_tax);
                                                } else {
                                                    tx = parseFloat(self.cost) * parseFloat(self.tax);
                                                }

                                            } else {

                                                if (self.cost > 0) {
                                                    tx = self.tax_amount;
                                                } else {
                                                    tx = 0;
                                                }
                                            }

                                        } else {

                                            if (self.quantity > 0){
                                                tx = parseFloat(self.cost) * parseFloat(self.tax);
                                                tx += parseFloat(self.quantity) * parseFloat(self.diesel_tax);
                                            }else{
                                                tx = parseFloat(self.cost) * parseFloat(self.tax);
                                            }
                                        }
                                        self.tax_amount = parseFloat(tx).toFixed(4);
                                        self.cost_error_msg="Cost not found in fuel drop for this product. Please add the cost in fuel drop."

                                    } else {

                                        self.price_val=self.amountFormat(data.content.price,4);
                                        self.cost = data.content.cost;
                                        // self.tax=data.content.tax;
                                        self.sales_tax = data.content.sales_tax;
                                        self.tax= parseFloat(data.content.tax_amt);
                                        self.diesel_tax = data.content.diesel_tax;
                                        self.aft_tax = data.content.aft_tax;
                                        self.dtax = data.content.dtax;
                                        var tx = 0;
                                        if (segments[3]) {

                                            if ( self.tax > 0 ) {

                                                if ( self.quantity != 0 ) {

                                                    if ( self.total != 0 ) {

                                                        if ( self.product_id && (self.product_id.item_code == 'DEF' ||  self.product_id.item_code == 'EXTDEF') ) {

                                                            tx = parseFloat(self.total) * parseFloat(self.sales_tax);

                                                        } else {

                                                            tx = parseFloat(self.total) * parseFloat(self.sales_tax);
                                                            tx += parseFloat(self.total) * parseFloat(self.aft_tax);
                                                            tx += parseFloat(self.quantity) * parseFloat(self.diesel_tax);
                                                        }

                                                    } else {

                                                        if ( self.product_id && (self.product_id.item_code == 'DEF' ||  self.product_id.item_code == 'EXTDEF') ) {

                                                            tx = parseFloat(self.cost) * parseFloat(self.sales_tax);

                                                        } else {

                                                            tx = parseFloat(self.cost) * parseFloat(self.sales_tax);
                                                            tx += parseFloat(self.cost) * parseFloat(self.aft_tax);
                                                            tx += parseFloat(self.quantity) * parseFloat(self.diesel_tax);
                                                        }

                                                    }

                                                } else {
                                                    tx = parseFloat(self.total) * parseFloat(self.sales_tax);
                                                }

                                            } else {
                                                tx = self.tax_amount;
                                            }

                                        } else {

                                            if ( self.quantity != 0 ) {

                                                if ( self.product_id && (self.product_id.item_code == 'DEF' ||  self.product_id.item_code == 'EXTDEF') ) {

                                                    tx = parseFloat(self.cost) * parseFloat(self.sales_tax);

                                                } else {

                                                    tx = parseFloat(self.cost) * parseFloat(self.sales_tax);
                                                    tx += parseFloat(self.cost) * parseFloat(self.aft_tax);
                                                    tx += parseFloat(self.quantity) * parseFloat(self.diesel_tax);
                                                }

                                            } else {
                                                tx = parseFloat(self.cost) * parseFloat(self.sales_tax);
                                            }
                                        }

                                        self.tax_amount = parseFloat(tx).toFixed(4);

                                    }
                                }

                            }
                        },
                        error: function (jqXHR, exception) {

                            console.log(jqXHR.responseJSON.message);
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR, false, 'fuel-price-on-product');
                        }
                    });
                } else {
                    self.price_val = 0;
                    self.total = 0;
                    self.ticket_total = 0;
                    self.tax = 0;

                }
            }
            self.fuelFlag=0;

        },
        getReading(flag){
            var self = this;
            var error = false;
            var sequenceError = "";
            if ( self.requestInprogress ) {
                return;
            }
            if(self.sequence_duplicate == true){
              error = true;
              return;
            }

            self.date_time_error_msg= "";
            self.product_error_msg="";
            self.customer_error_msg="";
            self.bill_type_error_msg="";
            self.quantity_error_msg= "",
            self.measurement_unit_error_msg="";
            self.price_error_msg="";
            self.ticket_total_error_msg="";
            self.status_error_msg="";
            self.common_error_msg = "";
            self.odometer_reading_error_msg = "";
            self.pump_error_msg = '';
            self.sequence_no_error_msg = '';
            self.reference_no_error_msg = '';
            var checkNumber = /^[0-9]+(\.[0-9]+)?$/;

            if (!self.quantity || self.quantity == null || self.quantity == "" || self.quantity== 0 ) {
                self.quantity_error_msg = "Quantity Required.";
                error = true;
            }

            // if (self.sequence == null || self.sequence == "") {
            //     self.sequence_no_error_msg = "Sequence Required.";
            //     error = true;
            // }
            // if (isNaN(self.sequence) || self.sequence % 1 !== 0) {
            //     self.sequence_no_error_msg = "Please Enter Number.";
            //     error = true;
            // }

            // sequenceError = self.validateLength(self.sequence, 1, 12);
            // if (sequenceError) {
            //   self.sequence_no_error_msg = sequenceError;
            //   error = true;
            // }

            // if ( self.vehicle_id == null ) {
            //     self.odometer_reading='';
            // }else{
            //     if (!self.odometer_reading || self.odometer_reading == null || self.odometer_reading == "") {
            //         self.odometer_reading_error_msg = "Odometer Reading Required.";
            //         error = true;
            //     } else {
            //         // check reading is valid or not...
            //         if ( !String(self.odometer_reading).match(checkNumber) ) {
            //             self.odometer_reading_error_msg = "Odometer Reading is not valid.";
            //             error = true;
            //         }
            //     }
            // }

            if ( (self.itemCode == "EXTDIESEL" || self.itemCode == "EXTDEF") && self.bill_type.value != 1 ) {
                //allowed price with 0 or null if item is external
            } else {

                if (self.customer_id != '000-00000000-000' && self.bill_type.value == 1){
                    if ( !self.price_val || self.price_val == null || self.price_val == "" || self.price_val == 0 ) {
                        self.price_error_msg = "Price Required.";
                        error = true;
                    }
                }

                if ( self.itemCode != "EXTDIESEL" && self.itemCode != "EXTDEF") {
                    if (self.pump_mapper_id == null || !self.pump_mapper_id.value) {
                        self.pump_error_msg = "Pump selection Required.";
                        error = true;
                    }
                }

            }

            if(self.price >0 && self.quantity >0 ) {
                if (!self.ticket_total || self.ticket_total == null || self.ticket_total == "" || self.ticket_total == 0) {
                    self.ticket_total_error_msg = "Total Never Be Zero.";
                    error = true;
                }
            }
            if (self.sectionArr.length != undefined){
                for(var j=0;j<self.sectionArr.length;j++){
                    self.sectionArr[j].reading_error = '';
                    if (self.sectionArr[j].reading == '' || self.sectionArr[j].reading == 0){
                        self.sectionArr[j].reading_error = 'Reading is required';
                        error = true;
                    }
                }
            }

            if (!self.date_time || self.date_time == null || self.date_time == "" ) {
                self.date_time_error_msg = "Date Required.";
                error = true;
            }

            if (self.product_id == null || !self.product_id.value) {
                self.product_error_msg = "Product Required.";
                error = true;
            }
            if (self.bill_type == null || !self.bill_type.value) {
                self.bill_type_error_msg = "Bill Type Required.";
                error = true;
            }

            if (!self.is_miscellaneous && (self.bill_type.value == 1 || self.bill_type == 1)){
                if (self.customer_id == null) {
                    self.customer_error_msg = "Customer Required.";
                    error = true;
                }
            }
            if(self.is_miscellaneous){
                console.log(self.reference_no.value);
                if (self.reference_no == "" || self.reference_no == null ) {
                    self.reference_no_error_msg = "Unit Required.";
                    error = true;
                }
            }
            if (self.measurement_unit_id == null || !self.measurement_unit_id.value) {
                self.measurement_unit_error_msg = "Measurement Unit  Required.";
                error = true;
            }

            if(!error){
                var fields_err = [];
                if (self.sectionArr.length != undefined){
                    for(var j=0;j<self.sectionArr.length;j++){
                        self.sectionArr[j].reading_error = '';
                        if(self.sectionArr[j].reading < self.sectionArr[j].lastreading){
                            var read_error = self.sectionArr[j].section +' : '+'Reading ' +  self.sectionArr[j].reading + ' is less than previous reading ' + self.sectionArr[j].lastreading;
                            fields_err.push(read_error);
                        }
                    }
                    if(fields_err.length != 0){
                        var fielderror = "";
                        for(var i = 0; i < fields_err.length; i++){
                            fielderror += "<span style='display: contents;font-size: 15px;font-weight: 300;'>" + fields_err[i] +"</span>" + "<br/>";
                        }
                        self.$swal({
                            title: fielderror + "Do you want to continue?",
                            type: 'info',
                            showCancelButton: true,
                            confirmButtonText: 'Yes',
                            cancelButtonText: 'No',
                            showCloseButton: false,
                            showLoaderOnConfirm: true,
                            customClass: 'swal2-overflow',
                        }).then((result) => {
                            console.log(result.value);
                            if (result.value) {
                                self.CreateFuelTicket(flag);
                            } else {
                                // error = true;
                            }
                        });
                    }else{
                        self.CreateFuelTicket(flag);
                    }
                }
            }


        },
        CreateFuelTicket(flag) {

          var self = this;
          self.currentFlag = flag;
          if (flag != 'save_and_continue_from_trigger'){
            if ( self.$route.params.id == undefined && flag != 'no_program' && self.vehicle_id != null ) {
              var miles = 0;
              var date = self.actual_from_date;
              miles = self.odometer_reading;
              date = self.date_time;
              self.$refs.triggerEnable.getMappedProgram(self.vehicle_id.value,miles,date,flag);
              return;
            }
          }else{
            flag = "Save and Continue";
          }
                self.loading = true;
                var path = window.location.pathname;
                var segments = path.split("/");
                if (segments[3])
                {
                    $("#createVehicleModelBtn").val("Updating ...");
                    $("#createVehicleModelBtn").prop("disabled", true);
                    $("#cancelVehicleModelBtn").prop("disabled",true);
                } else {
                    if (flag == "Save and Continue") {

                        $("#createAndContinueVehicleModelBtn").val("Saving ...");
                        $("#createVehicleModelBtn").prop("disabled", true);
                        $("#createAndContinueVehicleModelBtn").prop("disabled", true);
                        $("#cancelVehicleModelBtn").prop("disabled",true);

                    }else{

                        $("#createVehicleModelBtn").val("Saving ...");
                        $("#createVehicleModelBtn").prop("disabled", true);
                        $("#createAndContinueVehicleModelBtn").prop("disabled", true);
                        $("#cancelVehicleModelBtn").prop("disabled",true);
                    }

                }
                var fields = $('#fuelTicketCreate').serializeArray();

                if (self.vehicle_id == null || !self.vehicle_id.value) {
                    fields.push({name: "vehicel_id", value: ''});
                }else{
                    fields.push({name: "vehicel_id", value: self.vehicle_id.value});
                }
                // if (self.department_id == null || !self.department_id.value) {
                //    fields.push({name: "department_id", value: ''});
                // }else{
                //    fields.push({name: "department_id", value: self.department_id.value});
                // }
                fields.push({name: "product_id", value: self.product_id.value});
                if(self.bill_type == 1 || self.bill_type.value == 1){
                  console.log("in if");
                  fields.push({name: "customer_id", value: (self.customer_id) ? self.customer_id.value : 0});
                  fields.push({name: "price", value: self.removeFormat(self.price_val)});
                }else{
                  fields.push({name: "customer_id", value: (self.customer_id != null) ? self.customer_id.value : null});
                  fields.push({name: "price", value: (self.price_val != '') ? self.removeFormat(self.price_val) : 0});
                }
                fields.push({name: "bill_type", value: self.bill_type.value});
                fields.push({name: "measurement_unit_id", value: self.measurement_unit_id.value});
                fields.push({name: "total", value: self.removeFormat(self.total)});
                fields.push({name: "tax", value: self.tax_amount});

                if ( self.itemCode && (self.itemCode == 'DEF' ||  self.itemCode == 'EXTDEF') ) {
                    fields.push({name: "diesel_tax", value: 0});
                    fields.push({name: "aft_tax", value: 0});
                }else{
                    fields.push({name: "diesel_tax", value: self.diesel_tax});
                    fields.push({name: "aft_tax", value: self.aft_tax});
                }

                fields.push({name: "sales_tax", value: self.sales_tax});
                fields.push({name: "ticket_total", value: self.removeFormat(self.ticket_total)});
                fields.push({name: "cost", value: self.cost});
                fields.push({name: "date_time", value: self.date_time});
                fields.push({name:"signature",value:self.signature});
                fields.push({name:"flag",value:flag});
                if (self.pump_mapper_id != null && self.pump_mapper_id.value){
                    fields.push({name:"pump_mapper_id",value:self.pump_mapper_id.value});
                }

                if(self.is_miscellaneous == true){
                    fields.push({
                        name: "is_miscellaneous",
                        value: 1
                    });
                }else{
                    fields.push({
                        name: "is_miscellaneous",
                        value: 0
                    });
                }
                // fields.push({name:"odometer_reading",value:self.odometer_reading});
                fields.push({
                    name: "reading",
                    value: JSON.stringify(self.sectionArr)
                });

                fields.push({name: "id", value: segments[3]});


                self.requestInprogress = true;
                if(self.processflag == 0){
                    self.processflag = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/fuel-ticket/create",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        self.processflag = 0;
                        self.requestInprogress = false;
                        if (segments[3])
                        {
                            $("#createVehicleModelBtn").val("Update");
                            $("#createVehicleModelBtn").prop("disabled", false);
                            $("#cancelVehicleModelBtn").prop("disabled",false);
                        } else {
                            if (flag == "Save and Continue") {
                                self.sequence = parseInt(data.content.seq_number) + 1;
                                $("#createAndContinueVehicleModelBtn").val("Save and Continue");
                                $("#createVehicleModelBtn").prop("disabled", false);
                                $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                                $("#cancelVehicleModelBtn").prop("disabled",false);

                            }else{

                                $("#createVehicleModelBtn").val("Save");
                                $("#createVehicleModelBtn").prop("disabled", false);
                                $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                                $("#cancelVehicleModelBtn").prop("disabled",false);

                            }
                        }
                         if (data.status == 'count_exist') {
                            self.$swal('',data.content,'info');
                            return;
                        }
                        if (data.status == "success") {

                            if (flag == "Save and Continue") {
                                self.displaySchedule = false;
                                $("#fuelTicketCreate").trigger("reset");
                                self.sequence_duplicate = false;
                                self.measurement_unit_id = null;
                                self.quantity=0;
                                self.date_time=moment().format("MM/DD/YYYY hh:mm:ss a");
                                self.product_id=null;
                                self.customer_id=null;
                                var obj = self.billableCodeArr;
                                $.each(obj, function (key, billvalue) {
                                    if (billvalue.value == '1') {
                                        self.bill_type = {
                                            value: billvalue.value,
                                            text: billvalue.text,
                                        };
                                    }
                                });
                                self.vehicle_id=null,
                                // self.bill_type=null;
                                self.measurement_unit_id=null;
                                // self.department_id=null;
                                self.price_val=0;
                                self.total=0;
                                self.tax=0;
                                self.ticket_total=0;
                                self.location_id='';
                                self.pump_no='';
                                self.driver_id="";
                                self.card_no="";
                                self.reference_no="";
                                self.po_id="";
                                self.odometer_reading ="";
                                self.sales_tax = 0;
                                var obj = self.vomArr;
                                $.each(obj, function (key, uomvalue) {
                                    if (uomvalue.symbol == 'GAL') {
                                        self.measurement_unit_id = {
                                            value: uomvalue.value,
                                            text: uomvalue.text,
                                        };
                                    }
                                });

                            }else{
                                self.$router.push("/fuel-ticket/list");
                            }

                        } else {
                            if (data.content.length > 0) {

                                if ( flag == 'no_program') {
                                    self.displaySchedule = false;
                                }

                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                    self.common_error_msg += data.content[i] + "\n";
                                }
                                // $("#errorMsg").html(err);
                                // $(".alert-warning").toggleClass("show");
                                self.displaySchedule = false;
                                $("#trigger-message-modal").modal("hide");
                                setTimeout(function () {
                                    // $(".alert-warning").removeClass("show");
                                    // $(".alert-warning").addClass("hide");
                                    self.common_error_msg = "";
                                }, 20000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.processflag = 0;
                        if (segments[3])
                        {
                            $("#createVehicleModelBtn").val("Update");
                            $("#createVehicleModelBtn").prop("disabled", false);
                            $("#cancelVehicleModelBtn").prop("disabled",false);
                        } else {
                            if (flag == "Save and Continue") {

                                // $("#fuelTicketCreate").trigger("reset");

                                $("#createAndContinueVehicleModelBtn").val("Save and Continue");
                                $("#createVehicleModelBtn").prop("disabled", false);
                                $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                                $("#cancelVehicleModelBtn").prop("disabled",false);

                            }else{

                                $("#createVehicleModelBtn").val("Save");
                                $("#createVehicleModelBtn").prop("disabled", false);
                                $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                                $("#cancelVehicleModelBtn").prop("disabled",false);

                            }
                        }
                        self.generateStatusCodeMessage(jqXHR,true,'fuel-ticket-create')
                    }
                });
            }
        // }else{
        //             self.errorValidationFocus();
            // }
        },
        loadFuelTicket() {
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/fuel-ticket/" + segments[3],
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                    // console.log(data.content);
                        //if fuel ticket is already billed then we not allow user to update the ticket
                        setTimeout(function(){
                            if(data.content.status=='billed' || data.content.status=='processed' ){
                                if(data.content.status=='processed' && self.userRole == 'fueler'){
                                    self.cantAccessPage=false;
                                    return;
                                }else{
                                    if(data.content.status=='billed' ){
                                        self.cantAccessPage=false;
                                        return;
                                    }
                                }
                            }
                        },500);
                        self.date_time=data.content.ticket_date;
                        self.quantity=data.content.quantity;
                        self.sequence=data.content.seq_number;
                        self.seqCheck = data.content.seq_number;
                        self.itemCode = data.content.item_code;
                        // self.odometer_reading = data.content.odometer_reading;
                        if(data.content.product_id == null) {
                            self.product_id = null;
                        }else{
                            if (data.content.item_cat_code != undefined && data.content.item_cat_code != null) {

                                self.product_id = {
                                                    value: data.content.product_id,
                                                    text:self.titleCase(data.content.company_name + " (" + data.content.loc_code +") | " + data.content.item_name),
                                                    item_cat_code:data.content.item_cat_code,
                                                    item_code:data.content.item_code
                                                };
                            } else {

                                self.product_id = {
                                                    value: data.content.product_id,
                                                    text:self.titleCase(data.content.company_name + " (" + data.content.loc_code +") | " + data.content.item_name + " | " + data.content.tank_no),
                                                    item_code:data.content.item_code
                                                };
                            }

                            self.loadFieldData(['pump_mapper'],data.content.product_id);

                        }
                        self.location_id=self.titleCase(data.content.company_name + " (" + data.content.loc_code +")");

                        //don't load any value if code is external
                        if ( data.content.pump_no != "" && data.content.pump_no != null ) {
                            if ( data.content.tank_no == 1 ) {
                                self.pump_mapper_id = {text:'Diesel Tank: '+data.content.tank_no+ ' | Pump: '+data.content.pump_no,value:data.content.tank_pump_mapper_id};
                            } else {
                                self.pump_mapper_id = {text:'DEF Tank: '+data.content.tank_no+ ' | Pump: '+data.content.pump_no,value:data.content.tank_pump_mapper_id};
                            }

                        }

                        if(data.content.status == null) {
                            self.status = null;
                        }else{
                            self.status={value: data.content.status, text:self.titleCase(data.content.status)};
                        }
                        if(data.content.customer_id == null) {
                            self.customer_id = null;
                        }else{
                            self.customer_id={value: data.content.customer_id, text:self.titleCase(data.content.custCode + " |" + data.content.custName +" | "+ data.content.custStage)};
                        }
                        if(data.content.vehicle_id != null){
                            var vehicleData = self.titleCase(data.content.vUnitNo);
                            if(data.content.vtCode != null){
                                vehicleData += " | " + self.titleCase(data.content.vtCode);
                            }
                            if(data.content.vName != null){
                                vehicleData += " | " + self.titleCase(data.content.vName);
                            }
                            self.vehicle_id = {value: data.content.vehicle_id, text: vehicleData};
                        }else{
                            self.vehicle_id = null;
                        }

                        if(data.content.uom_id == null) {
                            self.measurement_unit_id = null;
                        }else{
                            self.measurement_unit_id = {value: data.content.uom_id, text: self.titleCase(data.content.measurement_unit + " (" + data.content.symbol +")")};
                        }
                        if(data.content.bill_type_code != undefined && data.content.bill_type_code != null && data.content.bill_type_code != '')  {

                                self.bill_type={value: data.content.bill_type_code, text: data.content.bill_type_code + " | " + data.content.billable_code_name}
                        } else{
                            self.bill_type=null;
                        }

                        self.total = self.amountFormat(data.content.total);
                        self.tax_amount = data.content.tax_amount;
                        self.tax = data.content.tax;
                        self.sales_tax = data.content.sales_tax;
                        self.cost = data.content.cost;
                        self.ticket_total = self.amountFormat(data.content.ticket_total);
                        // self.tax_amount = data.content.sales_tax;
                        self.price_val = data.content.price;
                        self.signature = data.content.signature;
                        // self.driver_id = data.content.driver_id;
                        self.card_no = data.content.card_number;
                        self.reference_no = data.content.referance_no;
                        self.po_id = data.content.po_number;
                        // self.vin = data.content.vin;
                        self.notes = data.content.notes;
                        self.priceDisabled = false;
                        if (data.content.reading != undefined && data.content.reading.length){
                            self.sectionArr = data.content.reading;
                        }

                        if(data.content.is_miscellaneous == 1){
                            $("#is_miscellaneous").prop("checked",true);
                            self.is_miscellaneous = true;
                            self.ref_label = 'Unit#';
                        }else{
                            $("#is_miscellaneous").prop("checked",false);
                            self.is_miscellaneous = false;
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'ticket-by-id')
                }
            });
        },
        titleCase(str) {
            if (str == null){
                return;
            } else{
                var value = str.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },
        onAssetChange() {
            var self = this;
            if (self.vehicle_id != null) {
                if (self.vehicle_id.value != null){
                    if (self.vehicle_id.customer_id != undefined){
                        self.customer_id = {text:self.vehicle_id.customer,value:self.vehicle_id.customer_id};
                    }else{
                        // self.customer_id = {text:"000-00000000-000 | VTRL",value:0, stage:'existing'};
                        self.customer_id = null;
                    }
                }
            }
        },
        onSequenceTypeIn() {
          var self = this;
          console.log(self.seqCheck);
          if(self.seqCheck == self.sequence){
            //when edit form is loaded then,
            self.sequence_no_error_msg = "";
            self.sequence_duplicate = false;
          }
        },
        // getSequenceNo() {

        //     var self = this;
        //     self.loading = true;
        //     $.ajax({
        //         url: process.env.ROOT_API + "/sequence/number",
        //         type: "POST",
        //         headers: this.ajxHeaders,
        //         dataType: "json",
        //         success: function (data) {
        //             self.loading = false;
        //             if (data.status == "success") {
        //                 self.sequence = data.content.sequence;
        //             }
        //         },
        //         error: function (jqXHR, exception) {
        //             self.loading = false;
        //             self.generateStatusCodeMessage(jqXHR, true, 'get-sequence-number');
        //         }
        //     });
        // },
    }
};
</script>

<style scoped>
.swal2-overflow{
  overflow-x: visible;
  overflow-y: visible;
  max-height: 550px !important;
  min-height: 550px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/FuelTicketCreate.vue